module.exports = __webpack_public_path__ + "img/gzh_qrcode.60371d78.jpg";